import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1badc801&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1badc801",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1badc801')) {
      api.createRecord('1badc801', component.options)
    } else {
      api.reload('1badc801', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1badc801&scoped=true", function () {
      api.rerender('1badc801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/index/index.vue"
export default component.exports